
import Instagram from "../../../assets/outline/Instagram.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function InstagramIcon({ className, dataTestid = "InstagramIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Instagram data-testid={dataTestid} className={classes} {...rest} />
  );
}
